"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


// eslint-disable-next-line import/prefer-default-export
var DEFAULT_TRANSACTION_WAIT_TIMEOUT = exports.DEFAULT_TRANSACTION_WAIT_TIMEOUT = 60 * 5 * 1000; // 5 mins
//# sourceMappingURL=defaults.js.map